import { render, staticRenderFns } from "./AssessmentsDesktop.vue?vue&type=template&id=59115d9b&scoped=true"
import script from "./AssessmentsDesktop.vue?vue&type=script&lang=js"
export * from "./AssessmentsDesktop.vue?vue&type=script&lang=js"
import style0 from "./AssessmentsDesktop.vue?vue&type=style&index=0&id=59115d9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59115d9b",
  null
  
)

export default component.exports